// The environment this user's linked account trades options in: "LIVE", "SHADOW", or null (neither
// enabled by an admin). `undefined` while loading. Read from the account's admin flags.
import { useEffect, useState } from "react";
import api from "@/lib/api";

export function useOptionsEnvironment() {
  const [env, setEnv] = useState(undefined);
  useEffect(() => {
    let alive = true;
    api.get("/options-access/me").then((r) => {
      const eff = r.data?.account?.effective || {};
      if (alive) setEnv(eff.LIVE?.enabled ? "LIVE" : eff.SHADOW?.enabled ? "SHADOW" : null);
    }).catch(() => { if (alive) setEnv(null); });
    return () => { alive = false; };
  }, []);
  return env;
}
